<template>
  <div v-if="storedProject" class="admin-page__content">
    <form>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <h2 class="mb-0">
            {{ $t("informaceOProjektu") }}
          </h2>
          {{ $t("proProjekt") }} {{ storedProject.projectName }}
        </div>
      </div>
    </form>
    <div class="mt-4">
      <div class="row">
        <div class="col-sm-8 col-lg-6 col-12">
          <div v-if="project" class="layout__box mt-4 border">
            <div class="layout__box__header justify-content-between">
              <h2 class="mb-0">
                {{ project.projectName }}
              </h2>
            </div>
            <div class="layout__box__content">
              <div class="dashboard__devices__row d-flex align-items-center justify-content-between">
                <span class="font-weight-normal" href="">
                  <span>{{ $t("CustomerId") }}</span>
                </span>
                <span class="gray-text text-extra-small">{{ project.customerId }}</span>
              </div>
              <div class="dashboard__devices__row d-flex align-items-center justify-content-between">
                <span class="font-weight-normal" href="">
                  <span>{{ $t("projectId") }}</span>
                </span>
                <span class="gray-text text-extra-small">{{ project.projectId }}</span>
              </div>
            </div>
            <div class="layout__box__content">
              <div class="dashboard__devices__row d-flex align-items-center justify-content-end">
                <RouterLink :to="{ name: 'adminProjectUsers' }" class="link-gray" href="">
                  <span>
                    <span class="text-extra-small">{{ users.length }}&nbsp;</span>
                    <span v-if="users.length === 0" class="">{{ $t("uzivatelu") }}</span>
                    <span v-if="users.length === 1" class="">{{ $t("uzivatel") }}</span>
                    <span v-if="users.length > 1 && users.length < 5" class="">{{ $t("uzivatele") }}</span>
                    <span v-if="users.length >= 5" class="">{{ $t("uzivatelu") }}</span>
                  </span>
                </RouterLink>
              </div>
              <div class="dashboard__devices__row d-flex align-items-center justify-content-end">
                <RouterLink :to="{ name: 'adminProjectServicesLimits' }" class="link-gray" href="">
                  <span>
                    <span class="text-extra-small">{{ services.length }}&nbsp;</span>
                    <span v-if="services.length === 0" class="">{{ $t("sluzeb") }}</span>
                    <span v-if="services.length === 1" class="">{{ $t("sluzba") }}</span>
                    <span v-if="services.length > 1 && services.length < 5" class="">{{ $t("sluzby") }}</span>
                    <span v-if="services.length >= 5" class="">{{ $t("sluzeb") }}</span>
                  </span>
                </RouterLink>
              </div>
              <div class="dashboard__devices__row d-flex align-items-center justify-content-end">
                <span class="text-extra-small">{{ devicesCount }} {{ $t("zarizeni") }}</span>
              </div>
            </div>
            <div class="w-100">
              <div class="btn btn-primary w-100" @click="showParameters(project)">
                {{ $t("upravit") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="openedParameters.length > 0">
      <div v-if="project !== {}">
        <ProjectDetail
          :opened="openedParameters"
          :project="selectedProject"
          @close-box="toggleDetailModal"
          @open-box="toggleDetailModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import ProjectDetail from "@/components/modals/admin/project/project.vue"
import { useProjectStore } from "@/store/modules/project"
import { useLoraStore } from "@/store/modules/devices/lora"

export default {
  components: {
    ProjectDetail
  },
  props: {},
  setup() {
    const projectStore = useProjectStore()
    const loraStore = useLoraStore()

    return { projectStore, loraStore }
  },
  data() {
    return {
      project: {},
      services: [],
      users: [],
      openedItem: {},
      selectedRows: [],
      editedProject: [],
      selectedProject: {},
      openedParameters: [],
      devicesCount: 0
    }
  },
  computed: {
    storedProject() {
      return this.projectStore.selectedProject
    }
  },
  mounted() {
    if (this.storedProject) {
      this.loadProject()
    }
  },
  watch: {
    storedProject() {
      if (this.storedProject) {
        this.reloadProjects()
      }
    }
  },
  methods: {
    loadProject() {
      this.project = {}
      axios
        .get(process.env.VUE_APP_API + "/projects/" + this.storedProject.projectId)
        .then((result) => {
          this.project = result.data.data
          this.loadUsers()
          this.loadServices()
          this.getDevicesCount()
        })
        .catch(() => {})
    },
    loadUsers() {
      this.users = []
      return axios
        .get(process.env.VUE_APP_API + "/users?limit=1000&customerId[eq]=" + this.storedProject.customerId)
        .then((result) => {
          this.users = result.data.data.filter((user) =>
            user.privileges.some(
              (privilege) =>
                (privilege.privilege === "ProjectAdmin" &&
                  privilege.projectId === this.storedProject.projectId &&
                  privilege.customerId === this.storedProject.customerId &&
                  privilege.projectId !== ".") ||
                (privilege.privilege === "CustomerAdmin" && privilege.customerId === this.storedProject.customerId)
            )
          )
          return true
        })
        .catch(() => {
          return true
        })
    },
    loadServices() {
      this.services = []
      return axios
        .get(process.env.VUE_APP_API + "/projects/" + this.storedProject.projectId + "/services?limit=1000")
        .then((result) => {
          this.services = result.data.data
          return true
        })
        .catch(() => {
          return true
        })
    },
    setRows(rows) {
      this.selectedRows = rows
    },
    toggleDetailModal(box) {
      if (this.openedParameters.indexOf(box) > -1) {
        if (box === "parameters") {
          this.openedParameters = []
        } else {
          this.openedParameters.splice(this.openedParameters.indexOf(box), 1)
        }
      } else {
        this.openedParameters.push(box)
      }
    },
    showParameters(item) {
      this.selectedProject = item
      this.openedParameters.push("parameters")
    },
    reloadProjects() {
      this.loraStore.getList({
        search: false,
        sort: "custDeviceName",
        currentPage: 0,
        rowsPerPage: 10
      })
      this.loadProject()
    },
    async getDevicesCount() {
      const res = await axios.get(
        `${process.env.VUE_APP_API}/projects/${this.storedProject.projectId}/devices/overview`
      )
      this.devicesCount = res.data.metadata.count
    }
  }
}
</script>

<style lang="scss" scoped></style>
